import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lib-animated-discount-icon',
  templateUrl: './animated-discount-icon.component.html',
  styleUrls: ['./animated-discount-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnimatedDiscountIconComponent {
  @Input() size = 2.5;
}
